import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Image } from 'semantic-ui-react';
import styles from '../Playlist.scss';
import { getSongImage } from '../../../lib/utils/playlist';

export default class Song extends React.Component {
  static propTypes = {
    actionCallback: PropTypes.func,
    actionTrigger: PropTypes.node,
    onSuccess: PropTypes.func,
    onFailure: PropTypes.func,
    addToPlaylist: PropTypes.func,
    parent: PropTypes.object,
    song: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
    this.onClick = this.onClick.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onFailure = this.onFailure.bind(this);
  }

  onClick(e) {
    if (this.props.actionCallback && !this.state.loading) {
      this.setState({ loading: true });
      this.props.actionCallback(
        e,
        this.props.song,
        this.props.parent,
        this.onSuccess,
        this.onFailure
      );
    }
  }

  onSuccess() {
    this.setState({ loading: false }, () => {
      if (this.props.onSuccess) this.props.onSuccess();
    });
  }

  onFailure() {
    this.setState({ loading: false });
    if (this.props.onFailure) this.props.onFailure();
  }

  render() {
    const { actionCallback, actionTrigger, song } = this.props;
    return (
      <div className={styles.songCard}>
        {(() => {
          const songImage = getSongImage(song, 64, 64);
          return (
            <div className={styles.songThumbnail}>
              {!songImage && <Icon name='music' />}
              {songImage && <Image src={songImage.url} />}
            </div>
          );
        })()}
        <div className={styles.songDetails}>
          <strong>
            {song.name}
          </strong>
          <br />
          <span className={styles.muted}>
            {song.artist}
          </span>
        </div>
        {actionCallback &&
          actionTrigger &&
          <div className={styles.songAction}>
            <span onClick={this.onClick}>
              {actionTrigger}
            </span>
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Song/index.js